import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57aa2060"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 mx-auto" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"pb-10 pb-lg-15\" data-v-57aa2060><h2 class=\"fw-bolder d-flex align-items-center text-dark\" data-v-57aa2060> Choose Plan <i class=\"fas fa-exclamation-circle ms-2 fs-7\" data-bs-toggle=\"tooltip\" title=\"Choose Plan\" data-v-57aa2060></i></h2><div class=\"text-gray-400 fw-bold fs-6\" data-v-57aa2060> If you need more info, please check out <a href=\"https://morrisonrecordsbureau.com/contact-us/\" target=\"_blank\" class=\"link-primary fw-bolder\" data-v-57aa2060>Help Page</a>. </div></div>", 1)
const _hoisted_6 = { class: "fv-row" }
const _hoisted_7 = { class: "row gap-6 gap-lg-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanCard = _resolveComponent("PlanCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (planItem) => {
                return (_openBlock(), _createBlock(_component_PlanCard, {
                  class: "col-lg-4 mb-lg-6",
                  key: planItem.id,
                  id: planItem.id,
                  name: planItem.name,
                  detail: 
                  planItem.detail ||
                  'If you need more info, please check it out'
                ,
                  price: _ctx.getPlanPriceByCurrency(planItem, 'usd'),
                  priceLabel: "Per verification",
                  keyFeatures: planItem.features,
                  onSelected: ($event: any) => (_ctx.selectedPlan = planItem)
                }, null, 8, ["id", "name", "detail", "price", "keyFeatures", "onSelected"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}